import React from 'react';
import Header from '../components/site/Header';
import Hero from '../components/site/Hero';
import Steps from '../components/site/Steps';
import Circuits from '../components/site/Circuits';
import Contact from '../components/site/Contact';
import Footer from '../components/site/Footer';
import { useSiteConfig } from '../context/SiteConfigContext';

const Home = () => {
  const { loading, config } = useSiteConfig();

  if (loading || !config) {
    return (
      <div className="min-h-screen bg-[#0e2a24] grid place-items-center text-white/60">
        <div className="animate-pulse text-sm">Chargement…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0e2a24]">
      <Header />
      <Hero />
      <Steps />
      <Circuits />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
